export default function hasNotification(document, userId) {
	return document.notification && !document.notification.seenBy.includes(userId);
}
